import { Component, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ErrorRequiredComponent } from '../errors/error-required/error-required';
import { DatePicker, DatePickerMonthChangeEvent } from 'primeng/datepicker';
import { fieldControlId } from '../field/field-control-id';

@Component({
  standalone: true,
  selector: 'app-calendar',
  imports: [DatePicker, ReactiveFormsModule, ErrorRequiredComponent],
  templateUrl: './calendar.html',
  styleUrl: './calendar.scss',
})
export class CalendarComponent {
  dateFormat = input<string>('dd.mm.yy');
  formCtrl = input.required<FormControl>();
  ctrlPlaceholder = input<string>('');
  ctrlName = input<string>('');
  ctrlLabel = input<string>();
  formCtrlId = input<string>();
  formCtrlType = input<string>('text');
  formCtrlClass = input<string>('');
  formCtrlIcon = input<string>();
  tooltip = input<string>();
  formCtrlIconRight = input<string>();
  isDisabled = input<boolean>(false);
  ctrlShowTime = input<boolean>(true);
  timeOnly = input<boolean>(false);
  showLabel = input<boolean>(true);
  shouldFocus = input<boolean>(false);
  minDateCtrl = input<Date>();
  maxDateCtrl = input<Date>();
  inline = input<boolean>(false);
  unavailableDays = input<Date[]>([]);
  hideErrors = input<boolean>(false);
  panelStyleClass = input<string>('');
  selectionMode = input<'single' | 'range' | 'multiple'>('single');
  numberOfMonths = input<number>(1);

  protected readonly inputId = fieldControlId(this.formCtrlId);

  keyReleased = output<boolean>();
  onMonthChange = output<DatePickerMonthChangeEvent>();
  inputLeft = output<string | number>();
  onEnterClicked = output<string>();

  handleMonthChanged(value: DatePickerMonthChangeEvent) {
    this.onMonthChange.emit(value);
  }
}
